export default ngModule => {

  ngModule.factory('PrimaryServiceNeeds', function (AonConfig) {

    const needs = AonConfig.formChoices.primary_service_needs || [];

    class PrimaryNeeds {

      getDefaultPrimaryNeed() {
        return null;
      }

      needFromCode(need) {
        return needs.find(_need => _need.code === need);
      }

      /**
       * Given services, set selected/unselected based on whether they are included
       * in the given need's service set
       * @param services: {ancillary:[], hospital:[]}
       * @param primaryNeed: str Code for the primary need
       * @return: a new copy of the services, with selection status updated
       */
      selectPrimaryNeedServices(services, primaryNeed) {
        const updatedServices = _.cloneDeep(services);
        const need = this.needFromCode(primaryNeed);
        if (!need) {
          return updatedServices;
        }
        (updatedServices.hospital || []).forEach(_service => {
          _service.selected = need.hospital_services.includes(_service.id);
        });
        return updatedServices;
      }
    }

    return new PrimaryNeeds();

  });


};



// WEBPACK FOOTER //
// ./src/services/primary-service-needs.js